import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IUserSelectorBuilder from "../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";
import { userHasPermission } from "../../../../utils/accessTree";

const mesesOpts = [
  { value: "01", label: "Enero" },
  { value: "02", label: "Febrero" },
  { value: "03", label: "Marzo" },
  { value: "04", label: "Abril" },
  { value: "05", label: "Mayo" },
  { value: "06", label: "Junio" },
  { value: "07", label: "Julio" },
  { value: "08", label: "Agosto" },
  { value: "09", label: "Septiembre" },
  { value: "10", label: "Octubre" },
  { value: "11", label: "Noviembre" },
  { value: "12", label: "Diciembre" }
];

const currentYear = new Date().getFullYear();
const aniosOpts = [
  { label: currentYear - 1, value: currentYear - 1 },
  { label: currentYear - 2, value: currentYear - 2 }
];

export type Inputs =
  | "tipoBusqueda"
  | "folioFactura"
  | "mes"
  | "anio"
  | "idVendedor"
  | "idLider";
export type Buttons = "buscar";

const hiddenIfNotFactura = values => values.tipoBusqueda !== "factura";
const hiddenIfFactura = values => values.tipoBusqueda === "factura";
const hiddenIfNotAsesor = values => values.tipoBusqueda !== "asesor";
const hiddenLider = values =>
  !!values.tipoBusqueda || !userHasPermission(59101);

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "tipoBusqueda",
      label: "Tipo de Búsqueda",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Por Periodo",
        data: [
          { value: "factura", label: "Por Factura" },
          { value: "asesor", label: "Por Asesor" }
        ]
      }
    },
    {
      name: "folioFactura",
      label: "Folio de Factura",
      bts: { mCol: 3 },
      component: ITextBuilder,
      props: {
        uppercase: true,
        hidden: hiddenIfNotFactura
      }
    },
    {
      name: "mes",
      label: "* Mes",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: mesesOpts,
        hidden: hiddenIfFactura
      }
    },
    {
      name: "anio",
      label: "Año",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: currentYear.toString(),
        data: aniosOpts,
        hidden: hiddenIfFactura
      }
    },
    {
      name: "idLider",
      label: "Líder Comercial",
      bts: { mCol: 3 },
      component: IUserSelectorBuilder,
      props: {
        hidden: hiddenLider
      }
    },
    {
      name: "idVendedor",
      label: "Vendedor",
      bts: { mCol: 4 },
      component: IUserSelectorBuilder,
      props: {
        hidden: hiddenIfNotAsesor
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 2 },
      component: IButtonBuilder
    }
  ],
  validations: {
    folioFactura: {
      requiredIfFactura: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda === "factura" && !value,
        message: () => "Campo obligatorio"
      }
    },
    mes: {
      requiredIfNotFactura: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda !== "factura" && !value,
        message: () => "Campo obligatorio"
      }
    },
    idVendedor: {
      requiredIfAsesor: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda === "asesor" && !value,
        message: () => "Campo obligatorio"
      }
    },
    idLider: {
      requiredIfNotPeriodo: {
        validator: (value, formValue) =>
          !formValue.tipoBusqueda && !value && userHasPermission(59101),
        message: () => "Campo obligatorio"
      }
    }
  },
  rows: [
    [
      "tipoBusqueda",
      "folioFactura",
      "mes",
      "anio",
      "idLider",
      "idVendedor",
      "buscar"
    ]
  ]
};

export const selectClubFormConfig: FormBuilderConfig<"idClub", "aceptar"> = {
  inputs: [
    {
      name: "idClub",
      label: "Seleccione el Club",
      bts: { mCol: 12 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: []
      }
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Aceptar",
      isSubmit: true,
      bts: { mCol: 12 },
      component: IButtonBuilder
    }
  ],
  validations: {
    idClub: {
      required: {
        validator: value => !value,
        message: () => "Seleccione un club"
      }
    }
  },
  rows: [["idClub"], ["aceptar"]]
};
